import React, { useState } from 'react'

import { FaqAccordion } from '@/components/Accordion/FaqAccordion'
import { faqData } from '@/slices/HomePage/mocks/faq/data'
import { Container, styled, Typography } from '@mui/material'

export const FaqSection: React.FC = () => {
  const [expandedId, setExpandedId] = useState<number | null>(null)

  const handleChange = (faqId: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedId(isExpanded ? faqId : null)
  }

  return (
    <StyledFullWidthWrapper>
      <Container maxWidth="lg">
        <StyledHeadline variant="h2">
          Frequently Asked Questions
        </StyledHeadline>
        <StyledContainer>
          <StyledFaqList>
            {faqData.map((faq) => (
              <FaqAccordion
                key={faq.id}
                question={faq.question}
                answer={faq.answer}
                expanded={expandedId === faq.id}
                onChange={handleChange(faq.id)}
              />
            ))}
          </StyledFaqList>
        </StyledContainer>
      </Container>
    </StyledFullWidthWrapper>
  )
}

const StyledFullWidthWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(5, 0),

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(8, 0),
  },
}))

const StyledContainer = styled('div')({
})

const StyledHeadline = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.primary.main,
  marginBottom: theme.headlineSectionGap.xs,

  [theme.breakpoints.up('md')]: {
    marginBottom: theme.headlineSectionGap.sm,
  },
}))

const StyledFaqList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))
